import { call, take, takeLatest, put } from 'redux-saga/effects'
import NProgress from 'nprogress'

import { apiClient } from 'Module/API/Client'

import * as CONST from 'Reducers/Location/const'
import * as ERRORS from 'Reducers/Errors/const'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'
import { callApi } from 'Reducers/apiCall'

/**
 * Get location by id
 *
 * @param action
 */
function* getLocationById(action) {
  const response = yield callApi(apiClient.getLocationById, action.locationId)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.GET_LOCATION_BY_ID_SUCCESS,
        payload: {
          locationById: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}
}

/**
 * Update location by id
 *
 * @param action
 */
function* updateLocationById(action) {
  const { callbacks, locationId, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(
    apiClient.updateLocationById,
    locationId,
    payload,
  )
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.UPDATE_LOCATION_BY_ID_SUCCESS,
        locationId: action.locationId,
        response: responseJson,
      })
      callbacks && callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Create location
 *
 * @param action
 */
function* createLocation(action) {
  const { callbacks, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(apiClient.createLocation, payload)
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.CREATE_LOCATION_SUCCESS,
    })
    callbacks.onSuccess()
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Get locations by city id
 */
function* getLocationsByCityId(action) {
  NProgress.start()

  const response = yield callApi(
    apiClient.getLocationsByCityId,
    action.cityId,
    action.includesInactive,
  )
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.GET_LOCATIONS_BY_CITY_ID_SUCCESS,
      payload: {
        locationsByCityId: responseJson,
      },
    })
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }

  NProgress.done()
}

/**
 * Get location types
 */
function* getLocationTypes() {
  NProgress.start()

  const response = yield callApi(apiClient.getLocationTypes)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.GET_LOCATION_TYPES_SUCCESS,
        payload: {
          locationTypes: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Archive location by location id
 *
 * @param action
 */
function* archiveLocation(action) {
  const { callbacks, id } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(apiClient.archiveLocation, id)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Get location by id watcher
 */
export function* watchGetLocationById() {
  yield takeLatest(CONST.GET_LOCATION_BY_ID, getLocationById)
}

/**
 * Update location by id watcher
 */
export function* watchUpdateLocationById() {
  yield takeLatest(CONST.UPDATE_LOCATION_BY_ID, updateLocationById)
}

/**
 * Create location watcher
 */
export function* watchCreateLocation() {
  yield takeLatest(CONST.CREATE_LOCATION, createLocation)
}

/**
 * Get locations by city id watcher
 */
export function* watchGetLocationsByCityId() {
  while (true) {
    const action = yield take(CONST.GET_LOCATIONS_BY_CITY_ID)
    yield call(getLocationsByCityId, action)
  }
}

/**
 * Get location types watcher
 */
export function* watchGetLocationTypes() {
  yield takeLatest(CONST.GET_LOCATION_TYPES, getLocationTypes)
}

/**
 * Archive location watcher
 */
export function* watchArchiveLocation() {
  yield takeLatest(CONST.ARCHIVE_LOCATION, archiveLocation)
}



// WEBPACK FOOTER //
// ./src/Reducers/Location/sagas.js